module.exports={"Clear search":"検索をクリア"};